import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Loader, Text, Theme, Button, ContainerControlSite, Logo } from '@simplybenefits/sb-ui-library';

import { login } from '../../actions/master.js';
import * as notifier from '../../actions/notifier.js';

class Login extends PureComponent {
    componentDidMount() {
        if (window.document.documentMode) {
            this.props.dispatch(notifier.displayBrowserMessage('Simply Benefits is best used with an updated browser such as Google Chrome or Microsoft Edge'));
        }

        if (window.location.href.indexOf('invalid-token') > -1) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Your session has expired, please login again.'
            }));
        } else if (window.location.href.indexOf('fail-no-access') > -1) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'You do not have permission to access the Master site. Make sure you are logged into your Simply Benefits email account.'
            }));
        } else if (window.location.href.indexOf('fail') > -1) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Login credentials failed.'
            }));
        }

        document.addEventListener("keydown", this._handleKeyPress, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyPress, false);
    }

    _login = () => {
        this.props.dispatch(login());
    };

    _handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this._login();
        }
    };

    render() {
        const styles = {
            form: {
                backgroundColor: Theme.colors.surface,
                boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
                margin: '20px auto 50px auto',
                padding: '20px',
                position: 'relative',
                width: '384px'
            }
        };
        return (
            <ContainerControlSite>
                <Logo whitelabel />

                <div style={styles.form}>
                    <Text
                        mediumLarge
                        bold
                        display="block"
                        align="left"
                        margin="20px 0"
                        customLinkStyle={{ lineHeight: '40px' }}
                    >
                        Master Login
                    </Text>

                    <Text
                        small
                        light
                        display="block"
                        align="left"
                        margin="20px 0"
                        customLinkStyle={{ lineHeight: '40px' }}
                    >
                        Gain access by logging in through your Simply Benefits Microsoft account.
                    </Text>

                    <Button
                        testid="sign-in-button"
                        onClick={this._login}
                        color="primary"
                        marginTop="20px"
                        fullWidth
                    >
                        Sign in with Microsoft
                    </Button>
                </div>

                {this.props.loader?.isLoading && <Loader isContainer/>}
            </ContainerControlSite>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default (connect(mapStateToProps)(Login));